import { Store } from 'react-notifications-component';
import Icons from '../Icons';
import './style.css';
const createNotification = (title, message, type, container = 'bottom-left') => {
  const checkicon = {
    success: 'Accept',
    danger: 'Info',
    info: 'Info',
    warning: 'WarningTriangle',
  };

  Store.addNotification({
    title: <Icons icon={checkicon[type]} color="#ffffff" size="28" />,
    message: message,
    type: type,
    insert: 'top',
    container: container,
    animationIn: ['animate__animated', 'animate__slideInLeft'],
    animationOut: ['animate__animated', 'animate__fadeOutLeft'],
    dismiss: {
      duration: 10000,
      onScreen: true,
      pauseOnHover: true,
      showIcon: true,
    },
  });
};

export default createNotification;
